import { UserState } from "./store/account/userSlice";
import { setLimitAlert } from "./store/one-query/chatsSlice";

export const HandleErrorForLimitations=({user,dispatch,errorMessage}:{user:UserState,dispatch:any,errorMessage:string})=>{
        if (user.IsAuthenticated&&user.isSubscribed) {
          if (errorMessage.includes("limit")) {
            dispatch(
              setLimitAlert({
                show: true,
                message: errorMessage,
                btnTitle: ""
              })
            );
          }
        } else if (user.IsAuthenticated&&!user.isSubscribed) {
          if (errorMessage.includes("limit")) {
            dispatch(
              setLimitAlert({
                show: true,
                message: errorMessage,
                btnTitle: "Go Premium",
                btnAction: "OpenUpgradePlans",
              })
            );
          }
        } else {
          dispatch(
            setLimitAlert({
              show: true,
              message: errorMessage,
              btnTitle: "Sign In for Free",
              btnAction: "NavigateToLogin",
            })
          );
        }                 

}